import { render } from "./PfSelectRestful.vue?vue&type=template&id=4d3c260c"
import script from "./PfSelectRestful.vue?vue&type=script&lang=js"
export * from "./PfSelectRestful.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__